import React, { createContext, useCallback, useContext, useState } from 'react';
import AlertModalOmni from './AlertModalOmni';

const AlertModalContext = createContext(null);

const INITIAL = {
	open: false,
	type: 'success',
	title: '',
	message: '',
	autoHideDuration: 3500,
	showCloseButton: true,
	hideProgress: false,
	disableBackdropClick: false,
	disableEscapeKeyDown: false,
	actions: null
};

export const AlertModalProvider = ({ children }) => {
	const [state, setState] = useState(INITIAL);

	const close = useCallback(() => {
		setState(prev => ({ ...prev, open: false }));
	}, []);

	const show = useCallback((opts = {}) => {
		setState({ ...INITIAL, ...opts, open: true });
	}, []);

	const success = useCallback((messageOrOpts, opts = {}) => {
		const payload = typeof messageOrOpts === 'string' ? { message: messageOrOpts, ...opts } : messageOrOpts;
		show({ type: 'success', ...payload });
	}, [show]);

	const error = useCallback((messageOrOpts, opts = {}) => {
		const payload = typeof messageOrOpts === 'string' ? { message: messageOrOpts, ...opts } : messageOrOpts;
		show({ type: 'error', ...payload });
	}, [show]);

	const warning = useCallback((messageOrOpts, opts = {}) => {
		const payload = typeof messageOrOpts === 'string' ? { message: messageOrOpts, ...opts } : messageOrOpts;
		show({ type: 'warning', ...payload });
	}, [show]);

	const info = useCallback((messageOrOpts, opts = {}) => {
		const payload = typeof messageOrOpts === 'string' ? { message: messageOrOpts, ...opts } : messageOrOpts;
		show({ type: 'info', ...payload });
	}, [show]);

	const value = { show, close, success, error, warning, info };

	return (
		<AlertModalContext.Provider value={value}>
			{children}
			<AlertModalOmni
				open={state.open}
				onClose={close}
				type={state.type}
				title={state.title}
				message={state.message}
				autoHideDuration={state.autoHideDuration}
				showCloseButton={state.showCloseButton}
				hideProgress={state.hideProgress}
				disableBackdropClick={state.disableBackdropClick}
				disableEscapeKeyDown={state.disableEscapeKeyDown}
				actions={state.actions}
			/>
		</AlertModalContext.Provider>
	);
};

export const useAlertModal = () => {
	const ctx = useContext(AlertModalContext);
	if (!ctx) {
		throw new Error('useAlertModal must be used inside <AlertModalProvider>');
	}
	return ctx;
};

export default AlertModalProvider;
